import React from "react";
import { Icon } from "@me8eon/icons";
import { EonUiTooltip } from "@eon-ui/eon-ui-components-react";
import styles from "./ImageUploader.module.scss";
import { AnimatedStatusText } from "./components/AnimatedStatus/AnimatedStatus";
import { ImageUploaderTooltipContent } from "./components/ImageUploaderTooltipContent/ImageUploaderTooltipContent";
import { useImageUploaderTextAreaPlugin } from "./useImageUploaderTextAreaPlugin";
import { AiClient } from "@me8eon/aiclient";

type Props = {
    ai: AiClient
    setSuggestions: (suggestions: string[]) => void
}

export const ImageUploaderTextAreaPlugin: React.FC<Props> = ({ ai, setSuggestions }) => {
    const { files, status, onIconClick, handleRemoveFile, hasFiles } = useImageUploaderTextAreaPlugin({
        ai,
        setSuggestions
    });

    return (
        <div className={styles.container}>
            <div onClick={onIconClick}
                id="image-uploader-icon-button"
                className={!hasFiles ? styles.uploadIcon : styles["uploadIcon--active"]}>
                <Icon name="file_image" />
            </div>
            <AnimatedStatusText
                status={status}
                loadingText="Processing image..."
                successText="Image processed successfully!"
                errorText="Failed to process image"
            />
            <EonUiTooltip slot="tooltip" placement="right" id="image-uploader-tooltip">
                <ImageUploaderTooltipContent files={files} onRemove={handleRemoveFile} />
            </EonUiTooltip>
        </div>
    );
};